@import '~less/global-variables';
@import '~less/bootstrap/legacy-mixins';

// Form
.signup-form-steps {
  position: relative;
  //min-height: 600px;
}
.signup-form-step {
  //position: absolute;
  width: 100%;
  opacity: 1;
}
.signup-form-step-animate-wrapper {
  position: relative;
  height: 600px;
  overflow: hidden;
}

// "Usename is valid" etc texts under inputs
.signup-form-validresult {
  margin-top: -15px;
  margin-bottom: 15px;
}

.signup-newsletter-label {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  color: @text-color;

  input[type='checkbox'] {
    margin: 5px 0 0;
    flex: none;
  }
}

.signup-next {
  margin-bottom: 15px;
}

// Pre-fetched tribe under "Join Trustroots" title
.signup-tribe {
  margin-bottom: 0;
  height: 30px;
  overflow: hidden;
  font-size: 18px;
}

// 1-2-3 steps
.signup-steps {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 30px 0 40px 0;
}
// Horizontal line between step indicators
.signup-step-line {
  display: block;
  width: 25px;
  height: 2px;
  margin: 0 15px 30px 15px;
  background-color: @gray-lighter;
}
.signup-step-indicator {
  margin: 0 auto 10px auto;
  font-size: 19px;
  clear: both;
  line-height: 30px;
  .square(30px);
  border-radius: 50%;
  background-color: @gray-lighter;
  color: @gray-light;
}
.signup-step-active {
  .signup-step-indicator {
    background-color: @brand-primary;
    color: #fff;
  }
}
